import React, { Fragment, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Components
import { GIButton } from 'app-components';

type FormValues = {
    answer: string
}
const SecurityQuestion = (props) => {
    const {
        tryAgain,
        lookUpUserDetails,
        userResponse,
        onSubmitAnswer,
        environment: {
            exchangeName,
            links: {
                LOGIN
            },
        }
    } = props;

    const questionAndAnsListLocal = (lookUpUserDetails && lookUpUserDetails.securityQuestions && lookUpUserDetails.securityQuestions.userSecQstnAnsList) || [];

    const { register, handleSubmit, formState: { errors }  } = useForm<FormValues>({ defaultValues:{} });
    const [isSubmited, setIsSubmited] = useState(false);

    const doLogin = () => {
        window.location.href = LOGIN;
    };

    const showNoDataFound = () => {
        return (
            <Fragment>
                <FormattedMessage id='anonymous.forgot_email.noMatchFound' values={{ exchangeName }}/>
                <div className="controls-container">
                    <GIButton type='button' id='updateNewTicketCategory' labelId={'anonymous.forgot_email.button.try'} onClickHandler={tryAgain}  />
                    <GIButton type='button' id='updateNewTicketCategory' labelId={'anonymous.forgot_email.button.login'}  onClickHandler={doLogin} />
                </div>
            </Fragment>
        );
    };
    const onSubmit = (data) => {
        setIsSubmited(true);
        onSubmitAnswer(data);
    };

    const showQuestionAnswer = () => {
        return (
            <Fragment>
                <div className="gi-input grid-row gi-stackform margin-t-0">
                    <label htmlFor="security_answer" className="gi-input__label padding-l-0">
                        {questionAndAnsListLocal[0].question}
                    </label>
                    <input
                        id='security_answer'
                        type='text'
                        className={'gi-input__input grid-col-12'}
                        {...register('answer', 
                            { required: true,
                                onChange:() => setIsSubmited(false)
                            })}
                    />
                    <div className='tablet:grid-col-12 text-left'>
                        {errors.answer?.type === 'required' && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.label.answer.required' /></p>}
                        { (isSubmited && userResponse && userResponse.status === 'FAILURE') && <p className="shown error--msg"><em><FontAwesomeIcon icon="exclamation"/></em><FormattedMessage id='anonymous.forgot_email.answer.notmatching'/></p>}
                    </div>
                </div>
                <div className="controls-container">
                    <GIButton id='updateNewTicketCategory' labelId={'anonymous.forgot_email.submit'} onClickHandler={handleSubmit(onSubmit)}  />
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <form
                onSubmit={handleSubmit(onSubmit)}
            >
                { questionAndAnsListLocal.length === 0 ? showNoDataFound() : showQuestionAnswer()}
                
            </form>
        </Fragment>
    );
};

export default SecurityQuestion;